<template>
  <div>
    <label class="custom-control custom-checkbox">
      <input type="checkbox" :checked="checked" class="custom-control-input" @change="$emit('change',$event.target.checked)">
      <span class="custom-control-indicator"></span>
      <span class="custom-control-description">{{label}}</span>
    </label>
  </div>
</template>

<script>
  export default{
    props: {
      label: {
        type: String,
        requiered: false
      },
      checked: {
        type: Boolean,
        requiered: false
      }
    }
  }
</script>

<style>    
    
</style>



// WEBPACK FOOTER //
// regularCheckbox.vue?1cc35048